import { IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from '@shared/config/constants/asset-extensions';

export const getAssetType = (assetUrl) => {
  if (!assetUrl || typeof assetUrl !== 'string') {
    return null;
  }

  const extension =
    assetUrl?.split('?')?.[0]?.split('#')?.[0]?.split('.')?.pop()?.toLowerCase() || '';

  if (IMAGE_EXTENSIONS.includes(extension)) {
    return 'image';
  }

  if (VIDEO_EXTENSIONS.includes(extension)) {
    return 'video';
  }

  return null;
};
